import React from "react";
import PropTypes from "prop-types";

import BaseButton from "../Button/BaseButton";
import BaseAnchor from "../Anchor/BaseAnchor";

import "./nav-bar.scss";

const NavBar = ({ menuDrawOpen, menu, onMenuClick, links }) => {
  return (
    <div className="nav-bar">
      <div className="nav-bar__inner">
        <BaseButton id="nav-bar-button" className="nav-bar__menu-btn" onClick={onMenuClick}>
          {menu.icon && menu.icon({ isActive: menuDrawOpen })}
          {menu.text}
        </BaseButton>
        <ul className="nav-bar__links">
          {links.map((link, i) => {
            return (
              <li key={i}>
                <BaseAnchor className="nav-bar__links-item-btn" to={link.to} onClick={link.onClick}>
                  {link.icon && link.icon({ className: "nav-bar__links-item-btn-icon" })}
                  {link.text}
                </BaseAnchor>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

NavBar.propTypes = {
  menu: PropTypes.shape({ text: PropTypes.string.isRequired, icon: PropTypes.func }).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      icon: PropTypes.func,
      to: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  menuDrawOpen: PropTypes.bool,
  onMenuClick: PropTypes.func.isRequired,
};

export default NavBar;
